module.exports = new __parcel__URL__("../images/logo-mj.6e71f820.png").toString();